import {useState, useEffect} from "react";
import {useSelector, useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {Button, Form, Input, Select, DatePicker, InputNumber} from "antd";
import {tutorAuthActions} from "../../../_actions";
import moment from "moment";
import {xcService} from "../../../_services/xcService";

import "../center.scss";

const {Option} = Select;

function StepOneCenter(props) {
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {t, i18n} = props;
    const [loading, setLoading] = useState(false);
    const [center, setCenter] = useState(null);

    var checkCodeCenter = useSelector((state) => state.tutorAuthReducer.infoCenterData);
    var tutorState = useSelector((state) => state.tutorAuthReducer);

    var checkCodeCenterError = useSelector(
        (state) => state.tutorAuthReducer.infoCenterError
    );
  
    const onFinish = (vals) => {
        props.goTo(vals, 1);
    }

    useEffect(() => {
        if (checkCodeCenter) {
            if (checkCodeCenter) {
                setCenter(checkCodeCenter)
                props.center(checkCodeCenter)
            }
        }
    }, [checkCodeCenter])

    useEffect(() => {
        xcService.get("/v1/tutor/contractemp/" + user.code).then(data => {

            if (data.data.data && data.data.data.code){
                const {setFieldsValue, getFieldValue} = form;
                try {

                    let mData = JSON.parse(data.data.data.values);
                    if (mData.code){
                        dispatch(tutorAuthActions.getInfoCenter({code: mData.code}));
                    }
                    props.courses.map((item, index) => {
                        if (mData[item.id + "_date"]){
                            mData[item.id + "_date"] = moment(mData[item.id + "_date"])
                        }
                    });
                    setFieldsValue(mData);
                }catch (e) {
                    console.error(e);
                }
            }
        })
    },[])

    const onChangeCod = (e) => {
        if (e.target.value.length > 4) {
            dispatch(tutorAuthActions.getInfoCenter({code: e.target.value}));
        }
    }
    return (

        <div>

            <Form className="authForm allHeightMobile" form={form}
                  onFinish={onFinish}
                  name="basic"
                  layout="vertical"
                  initialValues={{remember: true}}
                  autoComplete="off"
            >

                <Form.Item
                    name="code"
                    label={t("registercenter.codigoc")}
                    rules={[

                        {
                            required: true,
                            message: t("mandatory"),
                        },
                    ]}
                >
                    <Input placeholder={t("registercenter.codigoc")} onChange={onChangeCod}/>
                </Form.Item>
                {center &&
                    <div className={"infoCenterData"}>
                        <h4>{t("registercenter.nombrecentro")}</h4>
                        <p>
                            {center.Nombre}<br/>
                            {center.Domicilio}<br />
                            CP {center.CodPostal}

                        </p>
                    </div>
                }
                <Form.Item
                    label={t("contrato.centro.web")}
                    name="web"
                   >
                    <Input placeholder={t("contrato.centro.web")} />
                </Form.Item>

                <Form.Item
                    label={t("registercenter.tipocentro")}
                    name="type"
                    rules={[
                        {
                            required: true,
                            message: t("mandatory"),
                        },
                    ]}
                >
                    <Select
                        placeholder={t("registercenter.tipocentro")}
                        showSearch={true}
                        defaultActiveFirstOption={true}
                        filterOption={false}
                        notFoundContent={null}
                    >

                        <Option value={1} key={1}>
                            {t("registercenter.tipo1")}
                        </Option>
                        <Option value={2} key={2}>
                            {t("registercenter.tipo2")}
                        </Option>
                        <Option value={3} key={3}>
                            {t("registercenter.tipo3")}
                        </Option>

                    </Select>
                </Form.Item>
                <div className={"customLabel"}>{t("registercenter.datoses")}</div>
                {props.courses &&
                    <>

                        <div className={"infoCourses"}>
                            {props.courses.map((item, index) => (
                                <>
                                    <div id={item.id + "kk"} className={"customLabel customLabel-cursos"}>{item.name}</div>


                                    <Form.Item
                                        label={t("registercenter.fecha")}
                                        name={item.id + "_date"}
                                        className={"calandar"}
                                    >
                                        <DatePicker
                                           style={{width: 150}}
                                            format="DD/MM/YYYY"
                                            disabledDate={current => {
                                                return current && current < moment();
                                            }}
                                            placeholder={"DD/MM/YYYY"}/>
                                    </Form.Item>
                                    <Form.Item
                                        label={t("registercenter.num")}
                                        name={item.id + "_number"}
                                        className={"num-studens"}
                                    >
                                        <InputNumber placeholder={t("registercenter.num")} min={1}/>
                                    </Form.Item>
                                </>
                            ))}
                        </div>
                    </>
                }
                <Form.Item className="buttons-pre-next">
                    <Button loading={loading} /* disabled={!center} */ className="primaryButton buttonSizeS"
                            type="primary" htmlType="submit">
                        {t("next")}
                    </Button>
                </Form.Item>
            </Form>
        </div>

    )
}

export default withTranslation()(StepOneCenter);
